/* Liebreiz presentation polish, 30 September 2026. Additive; no commerce or data writes. */
(function (win) {
  'use strict';
  if (!win.document || win.LWSShopPolish20260930) return;
  const doc = win.document;
  const api = { version: '1.2.0', status: 'waiting', menus: 0 };
  win.LWSShopPolish20260930 = api;
  const style = doc.createElement('style');
  style.dataset.lwsShopPolish = '';
  style.textContent = `
    [data-lws-release]:is([data-lws-entry-route="home"],[data-lws-entry-route="wedding"],[data-lws-entry-route="braut"],[data-lws-entry-route="trauringe"]) #lr-service{display:none!important}
    :is(.lwss-zoom-button,.lws-mens-zoom-button,.lr-sample-gallery-zoom){display:none!important}
    :is(.lwss-media,.lws-mens-card-media,.lws-mens-detail-stage,[data-lr-detail-image]){touch-action:pan-y pinch-zoom!important}
    .lws-polish-menu-toggle{display:none}
    .lws-polish-top{position:fixed;right:20px;bottom:calc(80px + env(safe-area-inset-bottom));z-index:40;width:46px;height:46px;display:grid;place-items:center;padding:0;border:1px solid #d5d5da;border-radius:50%;background:#fff;color:#4c4d53;box-shadow:0 3px 18px #23232a22;font:25px/1 Arial,sans-serif;cursor:pointer}
    .lws-polish-top[hidden]{display:none!important}
    .lws-polish-top:hover{background:#f3f3f6}
    .lws-polish-top:focus-visible,.lws-polish-menu-toggle:focus-visible{outline:3px solid #9c3a79;outline-offset:3px}
    [data-lws-release] .lws-entry-appointment{flex-direction:row;min-height:38px}
    .lws-tn .lws-tn-detail dl{overflow-wrap:anywhere}
    @media(max-width:900px){
      [data-lws-release][data-lws-entry-ready="true"] .lr-header.lws-polish-header{display:grid;grid-template-columns:minmax(82px,1fr) auto auto;gap:10px 10px;padding:10px 16px;margin-top:10px;box-sizing:border-box;width:100%;min-width:0}
      [data-lws-release][data-lws-entry-ready="true"] .lr-header.lws-polish-header .lr-logo{grid-row:1;grid-column:1;min-width:0}
      [data-lws-release][data-lws-entry-ready="true"] .lr-header.lws-polish-header .lr-logo img{width:min(110px,100%);height:44px}
      .lws-polish-header .lws-polish-menu-toggle{grid-row:1;grid-column:3;display:flex;align-items:center;justify-content:center;gap:7px;min-width:44px;min-height:44px;padding:8px;border:1px solid #d9d9df;border-radius:7px;background:#fff;color:#414149;font:600 13px/1.2 var(--font-body-family,Arial,sans-serif);cursor:pointer}
      .lws-polish-menu-icon{display:grid;gap:4px;width:18px}
      .lws-polish-menu-icon i{height:2px;background:currentColor;border-radius:1px;display:block}
      [data-lws-release] .lws-polish-header .lws-entry-navigation,[data-lws-release][data-lws-entry-ready="true"] .lws-polish-header .lr-header-actions{display:contents}
      [data-lws-release] .lws-polish-header .lws-entry-appointment{grid-row:1;grid-column:2;min-height:40px;padding:6px 10px;font-size:12px;max-width:none;white-space:nowrap}
      [data-lws-release] .lws-polish-header .lws-entry-shopping{grid-row:2;grid-column:1/-1;display:flex;gap:16px;margin:0;width:100%;min-width:0;justify-content:space-between}
      [data-lws-release] .lws-polish-header .lws-entry-shopping .lws-entry-search{flex:1 1 0;max-width:none;width:0;min-width:0}
      [data-lws-release] .lws-polish-header .lws-entry-shopping input[type="search"]{font-size:16px;height:42px}
      [data-lws-release] .lws-polish-header .lws-entry-search-submit{height:42px}
      [data-lws-release][data-lws-entry-ready="true"] .lws-polish-header .lr-nav{grid-row:3;grid-column:1/-1;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));align-items:stretch;gap:0 16px;width:100%;min-width:0;overflow:visible;padding:8px 0;border-top:1px solid #ededf0}
      [data-lws-release][data-lws-entry-ready="true"] .lws-polish-header .lr-nav a{min-width:0;min-height:44px;font-size:15px;white-space:normal;overflow-wrap:anywhere}
      [data-lws-release] .lws-polish-header .lws-entry-contact{grid-row:4;min-height:44px;font-size:13px;justify-content:center;border-top:1px solid #ededf0}
      [data-lws-release] .lws-polish-header .lws-entry-contact:first-child{grid-column:1}
      [data-lws-release] .lws-polish-header .lws-entry-contact:nth-child(2){grid-column:2/-1}
      [data-lws-release] .lws-polish-header :is(.lr-nav,.lws-entry-contact)[hidden]{display:none!important}
      .lws-polish-top{right:14px;width:44px;height:44px}
    }
    @media(prefers-reduced-motion:reduce){html{scroll-behavior:auto!important}}
  `;
  doc.head.append(style);
  const menus = new WeakSet();
  const mobile = win.matchMedia('(max-width:900px)');
  let queued = false, topButton;

  function setupHeader(root) {
    const header = root.querySelector('.lr-header');
    const nav = header?.querySelector('.lr-nav');
    const appointment = header?.querySelector('.lws-entry-appointment');
    if (!header || !nav || !appointment) return;
    if (appointment.textContent !== 'Termin buchen') appointment.textContent = 'Termin buchen';
    if (menus.has(header)) return;
    menus.add(header);
    const contacts = [...header.querySelectorAll('.lws-entry-contact')];
    const button = doc.createElement('button');
    button.type = 'button';
    button.className = 'lws-polish-menu-toggle';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Menü öffnen');
    if (!nav.id) nav.id = 'lws-polish-navigation-' + (++api.menus);
    button.setAttribute('aria-controls', nav.id);
    const icon = doc.createElement('span');
    icon.className = 'lws-polish-menu-icon';
    icon.setAttribute('aria-hidden', 'true');
    for (let n = 0; n < 3; n++) icon.append(doc.createElement('i'));
    button.append(icon);
    const text = doc.createElement('span');
    text.textContent = 'Menü';
    button.append(text);
    header.append(button);
    header.classList.add('lws-polish-header');
    let open = false;
    function render() {
      const expanded = mobile.matches && open;
      button.setAttribute('aria-expanded', String(expanded));
      button.setAttribute('aria-label', expanded ? 'Menü schließen' : 'Menü öffnen');
      nav.hidden = mobile.matches && !open;
      contacts.forEach(link => { link.hidden = mobile.matches && !open; });
      header.dataset.lwsMenuOpen = String(expanded);
    }
    function close(returnFocus) {
      if (!open) return;
      open = false;
      render();
      if (returnFocus && mobile.matches) button.focus({ preventScroll: true });
    }
    button.addEventListener('click', () => { open = !open; render(); });
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && open) {
        event.preventDefault();
        close(true);
      }
    });
    nav.addEventListener('click', event => { if (event.target.closest('a')) close(false); });
    doc.addEventListener('click', event => { if (open && !header.contains(event.target)) close(false); });
    mobile.addEventListener('change', () => { open = false; render(); });
    render();
  }

  function tidyTeno(root) {
    for (const panel of root.querySelectorAll('.lws-tn')) {
      panel.setAttribute('aria-label', 'Teno – Ringe und Männerschmuck');
      for (const p of panel.querySelectorAll('p')) {
        const value = p.textContent.trim();
        if (/^Hersteller-Endpreis (je Stück|je Paar), inklusive gesetzlicher Umsatzsteuer\.$/.test(value) ||
            value === 'Onlinekauf wird vorbereitet. Lieferzeit und Händlerbestellbarkeit werden noch bestätigt.' ||
            value.startsWith('Interne Sortimentsvorschau:')) p.remove();
        else if (value === 'TRAURINGE & MÄNNERSCHMUCK · GESCHÜTZTE VORSCHAU')
          p.textContent = 'TENO · RINGE & MÄNNERSCHMUCK';
      }
      for (const link of panel.querySelectorAll('a')) {
        if (link.textContent.trim().startsWith('Herstellerprodukt ansehen')) link.remove();
      }
      for (const details of panel.querySelectorAll('details')) {
        const summary = details.querySelector('summary');
        if (summary?.textContent.trim() === 'Rauschmayer: persönlich konfigurieren') details.remove();
        else if (summary?.textContent.trim() === 'Produktdetails' && !details.dataset.lwsInitiallyOpen) {
          details.open = true;
          details.dataset.lwsInitiallyOpen = 'true';
        }
      }
    }
    // The same provider notice may also be rendered by the older Trauringe module.
    for (const details of root.querySelectorAll('details')) {
      if (details.querySelector('summary')?.textContent.trim() === 'Rauschmayer: persönlich konfigurieren')
        details.remove();
    }
  }

  function topControl(root) {
    if (topButton?.isConnected) return;
    topButton = doc.createElement('button');
    topButton.className = 'lws-polish-top';
    topButton.type = 'button';
    topButton.textContent = '↑';
    topButton.setAttribute('aria-label', 'Zurück nach oben');
    topButton.title = 'Zurück nach oben';
    topButton.hidden = true;
    doc.body.append(topButton);
    const update = () => { topButton.hidden = win.scrollY < 420; };
    win.addEventListener('scroll', update, { passive: true });
    topButton.addEventListener('click', () => {
      win.scrollTo({ top: 0, behavior: win.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      root.querySelector('.lr-logo')?.focus({ preventScroll: true });
    });
    update();
  }


  function tidySeller(root) {
    const expected = 'Ringe & Schmuck: Liebreiz Juwelier & Trauringlounge, Inh. Sven Schmidt Braut & Männersache – Kleidung: Liebreiz Brautmode e.K. · Kauf im Store nach Anprobe';
    const replacement = 'Verkäufer im Onlineshop: Sven Schmidt. Brautkleider und Anzüge: Kauf nach Anprobe im Store.';
    const normalize = value => value.replace(/\s+/g, ' ').trim();
    for (const paragraph of root.querySelectorAll('.lr-footer > p')) {
      const labels = [...paragraph.querySelectorAll('strong')].map(label => normalize(label.textContent));
      if (labels.length !== 2 || labels[0] !== 'Ringe & Schmuck:' || labels[1] !== 'Braut & Männersache – Kleidung:') continue;
      const clone = paragraph.cloneNode(true);
      clone.querySelectorAll('br').forEach(br => br.replaceWith(' '));
      if (normalize(clone.textContent) !== expected) continue;
      paragraph.textContent = replacement;
      paragraph.dataset.lwsSellerCopy = 'sven-schmidt-online-v1';
      api.sellerCopy = 'updated';
    }
  }

  function tidyCartText(root) {
    const changes = [
      ['data-lr-cart-mode', 'Testbestellung über Shopify. Der Test-Zahlungsanbieter wurde geprüft. Verwende ausschließlich die bereitgestellten Test-Zahlungsdaten.', 'Prüfe Deine ausgewählten Produkte und Ausführungen vor dem Weitergehen zur Kasse.'],
      ['data-lr-payment-note', 'Test-Zahlung: Es wird kein Geld abgebucht. Echte Zahlungsarten werden vor dem Verkaufsstart freigeschaltet.', 'Die verfügbaren Zahlungsarten siehst Du im nächsten Schritt. Eine Bestellung schließt Du erst nach Deiner abschließenden Bestätigung ab.']
    ];
    const visible = node => !node.hidden && node.getClientRects().length > 0 && win.getComputedStyle(node).visibility === 'visible';
    for (const cart of root.querySelectorAll('dialog.lr-cart[data-lr-cart][open]')) {
      if (!visible(cart)) continue;
      for (const [attribute, expected, replacement] of changes) {
        const paragraphs = cart.querySelectorAll('p[' + attribute + ']');
        if (paragraphs.length !== 1) continue;
        const paragraph = paragraphs[0];
        if (paragraph.closest('dialog') !== cart || paragraph.children.length || !visible(paragraph) || paragraph.textContent !== expected) continue;
        paragraph.textContent = replacement;
        api.cartCopyChanges = (api.cartCopyChanges || 0) + 1;
      }
    }
  }

  function scan() {
    queued = false;
    const root = doc.querySelector('[data-lws-release][data-lws-entry-ready="true"]');
    if (!root) return;
    setupHeader(root);
    tidyTeno(root);
    tidySeller(root);
    tidyCartText(root);
    // These controls are dedicated magnifiers; gallery arrows and the search icon stay intact.
    for (const control of root.querySelectorAll('.lwss-zoom-button,.lws-mens-zoom-button,.lr-sample-gallery-zoom')) control.remove();
    topControl(root);
    api.status = 'mounted';
  }
  function schedule() {
    if (queued) return;
    queued = true;
    win.queueMicrotask(scan);
  }
  const observer = new win.MutationObserver(schedule);
  observer.observe(doc.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-lws-entry-ready','data-lws-entry-route','open','hidden'] });
  doc.addEventListener('lws:entry-ready', schedule);
  doc.addEventListener('lws:mens-selection-ready', schedule);
  scan();
})(window);


